import {
  createSentenceDrillState,
  reduceSentenceDrill,
  type SentenceDrillMode,
  type SentenceDrillToken,
} from "@-/dev.improve.haniverse.lib.sentence.drill";
import { useEffect, useReducer, useRef } from "react";

/** Refetched equivalent segmentation must not erase already-produced words or hints. */
export function useSentenceDrillSession({
  mode,
  sentence,
  tokens,
}: {
  mode: SentenceDrillMode;
  sentence: string | null;
  tokens: readonly SentenceDrillToken[];
}) {
  const [state, dispatch] = useReducer(
    reduceSentenceDrill,
    { mode, tokens },
    createSentenceDrillState,
  );
  const seeded = useRef({ mode, sentence, tokens });
  useEffect(() => {
    const previous = seeded.current;
    const equivalent =
      previous.mode === mode &&
      previous.sentence === sentence &&
      previous.tokens.length === tokens.length &&
      previous.tokens.every((token, index) => {
        const next = tokens[index];
        return (
          next?.word === token.word &&
          next.pinyin === token.pinyin &&
          next.charOffset === token.charOffset
        );
      });
    if (equivalent) {
      return;
    }
    seeded.current = { mode, sentence, tokens };
    dispatch({ kind: "reset", mode, tokens });
  }, [mode, sentence, tokens]);
  return [state, dispatch] as const;
}
